<template>
    <div id="specialist-component">
        <main id="mainContent" class="padFixBoth">
            <div class="view">
                <div class="row">

                    <div v-if="role_id===1" class="col-12 col-md-4 mb-3">
                        <select data-select="on" v-model="prov_role_id" name="ciudad" id="ciudad" v-on:change="selectCompanyByRoleProvider($event)" class="required">
                            <option :value="0">Tipo de Proveedor*</option>
                            <option v-for="prov in providers" :value="prov.id" :key="prov.id">
                                {{ prov.name }}
                            </option>
                        </select>
                    </div>

                    <div v-if="role_id===1" class="col-12 col-md-4 mb-3">
                        <select data-select="on" v-model="inst_id" name="ciudad" id="ciudad" v-on:change="selectEmployees($event)" class="required">
                            <option :value="0">Empresa*</option>
                            <option v-for="lprov in list_providers" :value="lprov.id" :key="lprov.id">
                                {{ lprov.proveedor }}
                            </option>
                        </select>
                    </div>
                    <!-- Si el proveedor es una institución Mostramos este select -->
                    <div v-if="role_id===7 || role_id===1 && prov_role_id===7" class="col-12 col-md-4 mb-3" :class="[role_id===7 ? 'offset-sm-4':'']">
                        <select data-select="on" v-model="specialist_id" name="ciudad" id="ciudad" v-on:change="selectConsult()" class="required">
                            <option :value="0">Selecciona un Medico*</option>
                            <option v-for="esp in specialists" :value="esp.id" :key="esp.id">
                                {{ esp.nom_com }}
                            </option>
                        </select>
                    </div>

                </div>
            </div>
            <div class="view">
                <div class="row">
                    <div class="col-12 col-xl-2 mb-3 mb-sm-0">
                       <b-pagination pills align="fill" :hide-goto-end-buttons="true" :limit="3" v-model="pagination.current_page" :total-rows="pagination.total" :per-page="pagination.per_page" aria-controls="my-table" size="lg" v-on:change="onChange"></b-pagination>
                    </div>
                    <div class="col-12 col-xl-6 mb-3 mb-sm-0">
                        <input id="filter-input" class="al-inputs scr-input" v-model="filter" type="search" placeholder="Buscar por palabra">
                        <label for="filter-input" class="scr-supertext scr-extra">Buscar por palabra</label>
                    </div>
                    <div class="col-12 col-xl-2 mb-3 mb-sm-0">
                        <select class="float" v-model="sinesterOfSpecialist.limit" v-on:change="changeLimit">
                            <option :value="10">10</option>
                            <option :value="20">20</option>
                            <option :value="30">30</option>
                            <option :value="50">50</option>
                            <option :value="100">100</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="container-fluid">
                <div class="row">
                    <b-table sticky-header="100vh" stacked="md" id="my-table" striped hover :fields="fields" :busy="isBusy" :items="pagination.data" :filter="filter">
                        <!-- A virtual column -->
                        <template #cell(paciente)="{item}">
                            <span>{{ item.id }}</span>
                        </template>
                        <template #cell(paciente)="{item}">
                            <span>{{ item.sku }}</span>
                        </template>
                        <template #cell(motivo)="{item}">
                            <span>{{ item.relreason.name }}</span>
                        </template>
                        <template #cell(lugar)="{item}">
                            <span>{{ item.relplace.name }}</span>
                        </template>

                        <template #cell(pdf)="{item}">
                        <span v-if="item.pdf">
                            <a class="fileName float" :href="'../storage/siniestro/'+item.pdf" target="_blank">
                                <i class="fas fa-file-pdf"></i>
                            </a>
                        </span>
                        </template>
                        <template #cell(Acciones)="{item}">
                            <div class="dropdown">
                                <button class="btn btn-warning dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <i class="fas fa-cogs"></i>
                                </button>
                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    <a class="dropdown-item" href="javascript:void(0)" v-on:click="modificar=true;">Cargar Factura</a>
                                </div>
                            </div>
                        </template>
                        <template #table-busy>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Loading...</strong>
                            </div>
                        </template>
                    </b-table>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import {myMixins} from "../mixins/myMixins";
import {sinisterService} from "../../Services/Sinister.service";
import {supplierspecialistService} from "../../Services/SupplierSpecialist.service";
import {supplierinstitutionsService} from "../../Services/SupplierInstitutions.service";
import {rolesService} from "../../Services/Roles.service";
import {supplierambulancesService} from "../../Services/SupplierAmbulances.service";
import {supplierlaboratoriesService} from "../../Services/SupplierLaboratories.service";
import {supplierdentistsService} from "../../Services/SupplierDentists.service";
import {supplierradiologyService} from "../../Services/SupplierRadiologia.service";
import {supplieropticiansService} from "../../Services/SupplierOpticians.service";

export default {
    name: "consultation-component",
    mixins: [myMixins],
    props: {
        supplier_id: {
            type: Number,
            required: true
        },
        role_id: {
            type: Number,
            required: true
        },
        kind_consult: {
            type: Number || null,
            required: false,
            default: 0
        },
    },
    data() {
        return {
            prov_role_id: 0,
            specialist_id: 0,
            inst_id: 0,
            modificar: false,
            isBusy: false,
            filter: null,
            pagination: {
                current_page: 1,
                data: [],
                first_page_url: '',
                from: 0,
                last_page: 0,
                last_page_url: '',
                links: [],
                next_page_url: '',
                path: '',
                per_page: 0,
                prev_page_url: '',
                to: 0,
                total: 0,
            },
            sinesterOfSpecialist: {
                limit: 10,
                search: '',
                page: 1,
                where: [{
                    field: 'supplier_id',
                    operator: '=',
                    value: this.supplier_id,
                }, {
                    field: 'role_id',
                    operator: '=',
                    value: this.role_id,
                }],
            },
            fields: [
                {key: 'id'},
                {key: 'paciente'},
                {key: 'motivo'},
                {key: 'lugar'},
                {key: 'pdf'},

            ],
            specialists: [],
            institutions: [],
            providers: [],
            list_providers: [],
        }
    },
    methods: {
        onChange(page) {
            //console.log('onchange');
            this.sinesterOfSpecialist.page = page;
            this.index();
        },
        changeLimit() {
            this.index();
        },
        //SELECCIONO TODOS LOS ROLES
        async selectProvider() {
            this.providers = await rolesService.getProvidersForSinester();
        },

        async selectCompanyByRoleProvider($e) {
            let id = this.stateId($e);
            //console.log('selectCompanyByRoleProvider_id', id);
            switch (Number(id)) {
                case 3:
                    //console.log('ambulancia');
                    this.list_providers = await supplierambulancesService.getMany({});
                    break;
                case 4:
                    this.list_providers = await supplierspecialistService.getMany({});
                    break;
                case 7:
                    this.list_providers = await supplierinstitutionsService.getMany({});
                    break;
                case 10:
                    this.list_providers = await supplierlaboratoriesService.getMany({});
                    break;
                case 11:
                    this.list_providers = await supplierdentistsService.getMany({});
                    break;
                case 12:
                    this.list_providers = await supplierradiologyService.getMany({});
                    break;
                case 13:
                    this.list_providers = await supplieropticiansService.getMany({});
                    break;
            }
        },

        async selectEmployees($e) {
            let id = this.stateId($e);
            if (id === 7) {
                this.specialists = await supplierspecialistService.getMany({
                    where: [{
                        field: 'institution_id',
                        operator: '=',
                        value: this.inst_id,
                    }],
                });
            }
        },
        async index() {
            this.isBusy = true;
            //ESTE IF ES PARA CUANDO ES UNA INSTITUCION ESTA ACCEDIENDO A VER LOS SINIESTROS DE UN ESPECIALISTA
            if (this.institution_id !== 0 && this.institution_id !== null) {
                this.fields.push({key: 'Acciones'});
            }
            //ESTE SWITCH ES PARA SABER QUE ROL ES EL QUE ESTA ACCEDIENDO A VER LOS SINIESTROS
            switch (this.role_id) {
                case 1:
                    console.log('role', this.role_id);
                    await this.selectProvider();
                    break;
                case 4:
                    //especialista
                    //console.log('especialista');
                    this.pagination = await sinisterService.getMany(this.sinesterOfSpecialist);
                    break;

                case 7:
                    //clinica / hospital
                    this.institutions = await supplierinstitutionsService.getMany({});
                    this.specialists = await supplierspecialistService.getMany({
                        where: [{
                            field: 'institution_id',
                            operator: '=',
                            value: this.supplier_id,
                        }],
                    });
                    break;
            }
            this.isBusy = false;
        },
        async selectConsult() {

            this.sinesterOfSpecialist = {
                limit: 10,
                search: '',
                page: 1,
                where: [{
                    field: 'role_id',
                    operator: '=',
                    value: 4,
                }, {
                    field: 'supplier_id',
                    operator: '=',
                    value: this.specialist_id,
                }],
            }
            this.pagination = await sinisterService.getMany(this.sinesterOfSpecialist);
        }
    },
    mounted() {
        this.index();
    }
}
</script>

